import Draggable from 'react-draggable' ;
import ModalDialog from 'react-bootstrap/ModalDialog';
import React from "react";

export class DraggableModalDialog extends React.Component {
    render() {
        return <Draggable handle=".modal-header"><ModalDialog {...this.props} />
        </Draggable>;
    }
}
